import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";

import { useDispatch, useSelector } from "react-redux";
import useApiStatusDispatch from "../../../hooks/useApiStatusDispatch";
import { createTrainerPageService, editTrainerPageService, getTrainerPageServices, removeTrainerPageService, selectAllServices } from "../../../state/trainerPageSlice";
import useS3DirectUpload from "../../../hooks/useS3DirectUpload"
import Card from "react-bootstrap/esm/Card";
import Carousel from "react-bootstrap/Carousel"
import { Link } from "react-router-dom";
import classes from "./trainerPagesServices.module.css"
import  "./trainerPagesServicesStyles.css"

const Service = ({ service, setShowCustomServices, setDataToEdit, handleSelect }) => {

    const dispatch = useDispatch();
    const statusDispatch = useApiStatusDispatch();



    function handleDelete(id) {
        let payload = {
            id,
        }
        statusDispatch(removeTrainerPageService(payload), "service", "delete");
        handleSelect(0);
    }

    function handleEdit() {
        setShowCustomServices(true);
        setDataToEdit(service)
    }



    return (
        <div>
            <div className={`${classes.carouselItem}`}  >
                <img className={classes.carouselImage} src={service.img} />
            </div>
            <Carousel.Caption className={classes.carouselCaption}>
                <h5>
                    <strong style={{color:"white"}}>{service.title}</strong>
                </h5>
                <p className={classes.carouselItemDescription}>
                    {service.description}
                </p>
                <Button
                    className="mr-2"
                    size="sm"
                    variant="outline-danger"
                    onClick={() => handleDelete(service.id)}
                > <i className="fa fa-trash" />
                </Button>
                <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() => handleEdit(service.id)}
                >

                    <i className="fa fa-edit" />
                </Button>
            </Carousel.Caption>

        </div>
    )
}

const ServicesAddEditModal = ({ setShowCustomServices, showCustomServices, dataToEdit, setDataToEdit }) => {

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [preview, setPreview] = useState("");
    const [isSaving, setIsSaving] = useState("");
    const [editingMode, setEditingMode] = useState(false);
    const [id, setId] = useState(null);
    const [servicesListLoading, setServicesListLoading] = useState(false);

    const dispatch = useDispatch();

    const statusDispatch = useApiStatusDispatch();


    const {
        file: upload,
        processUpload,
        setUpload,
        clearUpload
    } = useS3DirectUpload();

    useEffect(() => {
        dispatch(getTrainerPageServices())
    }, []);


    useEffect(() => {
        if (dataToEdit) {
            const { title, description, img, id } = dataToEdit;
            setTitle(title);
            setDescription(description);
            setPreview(img);
            setEditingMode(true)
            setId(id)
        }

    }, [dataToEdit])

    function clearData() {
        setDataToEdit(null);
        clearUpload();
        setTitle("");
        setDescription("");
        setPreview("");
        setEditingMode(false)
        setId("")
    }

    const doUpload = async () => {
        if (!upload) {
            return;
        }
        console.log(upload)
        console.log("fired");
        const s3Res = await processUpload()
        return s3Res;
    }

    const handleUpload = (file) => {
        // create the preview
        setUpload(file)
        const objectUrl = URL.createObjectURL(file)
        setPreview(objectUrl)
    }


    function handleCreate() {
        setIsSaving(true)
        doUpload()
            .then(res => {
                let payload = {
                    title,
                    description,
                };

                if (res?.success) {
                    payload.img = res.payload.url
                }

                statusDispatch((createTrainerPageService(payload)), "service", "create")
                    .then(res => {
                        setIsSaving(false);
                        setShowCustomServices(false);
                        clearData();
                    })
            })
    }

    function handleEdit() {
        setIsSaving(true)

        doUpload()
            .then(res => {
                setIsSaving(false)
                let payload = {
                    title,
                    description,
                    id,
                    // send existing image url
                    img: preview,
                };
                // if new image uploaded send new image
                if (res?.success) {
                    payload.img = res.payload.url
                }

                statusDispatch(editTrainerPageService(payload), "service", "update")
                setShowCustomServices(false);
                clearData();
            })
    }


    return (
        <Modal
            show={showCustomServices}
            onHide={() => { setShowCustomServices(false); clearData(); }}
        >
            <Modal.Header closeButton>
                <Modal.Title >
                    {editingMode ? "Edit" : "Add"}  Service
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form >
                    <Form.Group >
                        <Form.Label > Title </Form.Label>
                        <Form.Control
                            maxLength="70"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group >
                        <Form.Label> Description  </Form.Label>
                        <Form.Control
                            maxLength="250"
                            as="textarea"
                            rows="5"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>
                    <div className="mb-2"> Upload Image </div>

                    {preview &&
                        <div className="mb-2">
                            <img src={preview} style={{ maxHeight: "150px" }} />
                            <br />
                            <Button
                                variant="link"
                                className="text-danger"
                                size="sm"
                                onClick={() => { clearUpload(); setPreview("") }}
                            >
                                Remove Upload
                            </Button>
                        </div>}
                    <label for={`image-upload-service`} className="btn btn-success btn-sm w-50">
                        Upload {preview && "New"} Image
                    </label>
                    <input type="file" id={`image-upload-service`} style={{ display: "none" }}
                        onChange={(e) => {
                            handleUpload(e.target.files[0])
                        }}
                    />
                </Form>
                <Button
                    disabled={isSaving}
                    className="float-right"
                    size="sm"
                    onClick={() => editingMode ? handleEdit() : handleCreate()}
                > {isSaving ? <Spinner size="sm" animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner> : "Save"}  </Button>
            </Modal.Body>
        </Modal>
    )
}

function TrainerPageServices() {

    const [showCustomServices, setShowCustomServices] = useState("");
    const [dataToEdit, setDataToEdit] = useState(null);

    const services = useSelector(selectAllServices);
    const servicesStatus = useSelector(state => state.trainerPage.servicesStatus);

    //Carousel
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    }



    return (

        <div className="mb-5">
            <div className="mb-3">
                <Link to={`/profile`}>Profile Page</Link>
            </div>

            <h1> Trainer Page Services </h1>
            <i class="fa fa-info-circle mr-1"> </i>Use the left (<i class="fa fa-angle-left">) </i> and right (<i class="fa fa-angle-right">)  </i> indicators 
            to switch between services. 

            <hr />
            <div className="d-flex justify-content-end">
                <Button
                    className="mb-2 mr-4"
                    onClick={() => setShowCustomServices(true)}
                >
                    Add Service
                </Button>
            </div>

            <div className="w-100">
                {["init", "loading"].includes(servicesStatus) ? <Spinner animation="border" variant="primary" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner> :
                    <Carousel activeIndex={index}
                        onSelect={handleSelect}
                        interval={null}
                        variant="dark"
                        id="trainerPageServicesCarousel"
                        className={classes.carousel}>
                        {services.map(service => {
                            return <Carousel.Item>
                                <Service
                                    handleSelect={handleSelect}
                                    service={service}
                                    setShowCustomServices={setShowCustomServices}
                                    setDataToEdit={setDataToEdit}
                                />
                            </Carousel.Item>
                        })}
                    </Carousel>
                }
            </div>

            <ServicesAddEditModal
                showCustomServices={showCustomServices}
                setShowCustomServices={setShowCustomServices}
                dataToEdit={dataToEdit}
                setDataToEdit={setDataToEdit}
            />
        </div >
    );
}

export default TrainerPageServices;